"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const redux_1 = require("redux");
const react_redux_1 = require("react-redux");
const Page_1 = require("../../core/base/Page");
const Block_1 = require("../../core/base/Block");
const Header_1 = require("../components/Header");
const Footer_1 = require("../components/Footer");
const cw_component_authentication_1 = require("@dialogexe/cw-component-authentication");
const userProfile_1 = require("@dialogexe/cw-website-store/userProfile");
class PageHeaderFooter extends Page_1.Page {
    constructor() {
        super(...arguments);
        this.componentDidUpdate = (nextProps) => {
            if (!nextProps.userProfile.userProfile.Token && this.props.userProfile.userProfile && this.props.userProfile.userProfile.Token) {
                if (typeof window !== 'undefined') {
                    window.location.pathname = "/min-side";
                }
            }
        };
        this.handleOpenLoginModal = () => {
            this.setState({ loginModalOpen: true });
        };
        this.handleCloseLoginModal = () => {
            this.setState({ loginModalOpen: false });
            this.props.userProfileAction.deleteLoginFailedError();
        };
        this.handleLogin = (email, password) => {
            this.props.userProfileAction.fetchUserProfile(email, password);
        };
        this.handleForgotPassword = (email) => {
            this.props.userProfileAction.requestNewPassword(email);
        };
    }
    render() {
        return (React.createElement("div", null,
            this.renderHelmet(),
            this.renderHeader(),
            this.renderPage(),
            this.renderFooter(),
            this.state.loginModalOpen &&
                React.createElement(cw_component_authentication_1.default, { onClose: this.handleCloseLoginModal, onRequestClose: this.handleCloseLoginModal, onSubmit: this.handleLogin, onForgotPassword: this.handleForgotPassword })));
    }
    renderHeader() {
        return (React.createElement(Header_1.Header, { logo: this.state.theme.logo, menu: this.state.theme.menu.filter(item => item.locale === this.state.activeLocale), search: this.state.theme.search, language: this.state.theme.language, partners: this.state.partners, openLoginModal: this.handleOpenLoginModal }));
    }
    renderPage() {
        return (React.createElement("main", null, this.state.template.rows.map((row) => (React.createElement("div", { key: row.index, className: `row ${row.container ? 'container' : ''}` }, row.columns.map((column) => (React.createElement("div", { key: column.index, className: [
                'column',
                `is-xs-${column.screen.xs.span}`,
                `is-md-${column.screen.md.span}`,
                `is-lg-${column.screen.lg.span}`,
                `order-xs-${column.screen.xs.order}`,
                `order-md-${column.screen.md.order}`,
                `order-lg-${column.screen.lg.order}`,
            ].join(' ') }, this.findBlocks(row.index, column.index).map((block) => (React.createElement(Block_1.Block, Object.assign({ key: block.id }, this.getBlockProps(block)))))))))))));
    }
    renderFooter() {
        return (React.createElement(Footer_1.Footer, { logo: this.state.theme.logoAlt || this.state.theme.logo, footer: this.state.theme.footer.filter(item => item.locale === this.state.activeLocale), menu: this.state.theme.menu.filter(item => item.locale === this.state.activeLocale) }));
    }
}
exports.PageHeaderFooter = PageHeaderFooter;
exports.default = react_redux_1.connect((state) => ({
    userProfile: state.userProfile
}), (dispatch) => ({
    userProfileAction: redux_1.bindActionCreators(userProfile_1.actionCreators, dispatch)
}))(PageHeaderFooter);



// WEBPACK FOOTER //
// ./src/layouts/pages/page-header-footer.tsx